import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: 250,
    marginTop: 0,
    zIndex: 2,
  },
}));
